import { render, staticRenderFns } from "./SystemSettingsSocialMedia.vue?vue&type=template&id=0c4e24f8"
import script from "./SystemSettingsSocialMedia.vue?vue&type=script&lang=js"
export * from "./SystemSettingsSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports